/**
 * SWAPT BOGO collection — progress, chips, gift lock, inline Autoship, extra products.
 * Does not implement Shopify BXGY. Qualifying spend is a storefront mirror.
 */
(function () {
  "use strict";

  var PRODUCT_URL = function (h) {
    return "/products/" + encodeURIComponent(h) + ".js";
  };
  var COLLECTION_PRODUCTS_URL = function (handle, page) {
    return (
      "/collections/" +
      encodeURIComponent(handle) +
      "/products.json?limit=250&page=" +
      (page || 1)
    );
  };

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "$0";
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    var amount = cents / 100;
    if (amount % 1 === 0) return "$" + amount.toFixed(0);
    return "$" + amount.toFixed(2);
  }

  function toCents(value) {
    if (value == null || value === "") return 0;
    if (typeof value === "number") {
      return value < 1000 && value % 1 !== 0 ? Math.round(value * 100) : Math.round(value);
    }
    var n = parseFloat(String(value).replace(/[^0-9.]/g, ""));
    if (isNaN(n)) return 0;
    if (String(value).indexOf(".") !== -1) return Math.round(n * 100);
    return n < 1000 ? Math.round(n * 100) : Math.round(n);
  }

  function parseConfig(root) {
    var el = root.querySelector("[data-swapt-json]");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return {};
    }
  }

  function skioPlans(product) {
    return (product.selling_plan_groups || [])
      .filter(function (g) {
        return String(g.app_id || "").toUpperCase() === "SKIO";
      })
      .reduce(function (list, g) {
        return list.concat(g.selling_plans || []);
      }, []);
  }

  function planPct(plan) {
    var adj = plan && plan.price_adjustments && plan.price_adjustments[0];
    if (!adj) return 0;
    var kind = String(adj.value_type || "").toLowerCase();
    return kind === "percentage" ? Number(adj.value) || 0 : 0;
  }

  function allocMap(variant) {
    var map = {};
    ((variant && variant.selling_plan_allocations) || []).forEach(function (a) {
      var id = a.selling_plan_id || (a.selling_plan && a.selling_plan.id);
      if (id != null) map[String(id)] = toCents(a.price);
    });
    return map;
  }

  function pickSixtyPlan(plans) {
    return (
      (plans || []).find(function (p) {
        return /60/.test(String(p.name || ""));
      }) ||
      (plans && plans[plans.length - 1]) ||
      (plans && plans[0]) ||
      null
    );
  }

  function planNoteHtml() {
    return '<p class="swapt-card__cadence">Ships every 60 days.</p>';
  }

  function qtyHtml() {
    return (
      '<div class="swapt-card__qty" data-swapt-qty hidden>' +
      '<button type="button" class="swapt-card__qty-btn" data-swapt-qty-dec aria-label="Decrease quantity">−</button>' +
      '<span class="swapt-card__qty-val" data-swapt-qty-val aria-live="polite">0</span>' +
      '<button type="button" class="swapt-card__qty-btn" data-swapt-qty-inc aria-label="Increase quantity">+</button>' +
      "</div>"
    );
  }

  function setLoading(el, on) {
    if (!el) return;
    el.classList.toggle("is-loading", Boolean(on));
    el.setAttribute("aria-busy", on ? "true" : "false");
  }

  function parseAlloc(raw) {
    try {
      return JSON.parse(raw || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function paintCardPrice(card) {
    if (!card) return;
    var priceEl = card.querySelector("[data-swapt-card-price]");
    var compareEl = card.querySelector("[data-swapt-card-compare]");
    var saveEl = card.querySelector("[data-swapt-card-save]");
    if (!priceEl) return;
    var vSel = card.querySelector("[data-swapt-variant-select]");
    var opt = vSel && vSel.selectedOptions[0];
    var otp = opt ? Number(opt.getAttribute("data-price") || 0) : Number(card.getAttribute("data-otp-price") || 0);
    var compareAt = opt
      ? Number(opt.getAttribute("data-compare") || 0)
      : Number(card.getAttribute("data-compare-at") || 0);
    var planId = card.getAttribute("data-swapt-plan-id");
    var isGift = card.getAttribute("data-swapt-role") === "gift";
    var current = otp;
    var savePct = Number(card.getAttribute("data-save-pct") || 0);
    if (!isGift && planId) {
      var alloc = parseAlloc((opt && opt.getAttribute("data-alloc")) || card.getAttribute("data-alloc"));
      var auto = alloc[String(planId)] != null ? Number(alloc[String(planId)]) : NaN;
      if (isNaN(auto)) auto = Math.round((otp * (100 - savePct)) / 100);
      current = auto;
      if (compareAt <= current) compareAt = otp;
    }
    priceEl.textContent = formatMoney(current);
    if (compareEl) {
      if (compareAt > current) {
        compareEl.textContent = formatMoney(compareAt);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (saveEl) {
      if (!isGift && planId && (savePct > 0 || (compareAt > current && current > 0))) {
        var shown = savePct || Math.round(((compareAt - current) / compareAt) * 100);
        saveEl.textContent = "Save " + shown + "%";
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }
  }

  function injectAutoship(card, product) {
    if (!card || card.getAttribute("data-swapt-role") === "gift") return;
    var add = card.querySelector("[data-swapt-ajax-atc]");
    var plans = skioPlans(product);
    var vSel = card.querySelector("[data-swapt-variant-select]");
    if (vSel) {
      Array.prototype.forEach.call(vSel.options, function (opt) {
        var variant = (product.variants || []).find(function (v) {
          return String(v.id) === String(opt.value);
        });
        if (variant) opt.setAttribute("data-alloc", JSON.stringify(allocMap(variant)));
      });
    }
    var firstVar =
      (product.variants || []).find(function (v) {
        return String(v.id) === String(card.getAttribute("data-default-variant-id"));
      }) || (product.variants || [])[0];
    if (firstVar) {
      card.setAttribute("data-otp-price", String(toCents(firstVar.price)));
      card.setAttribute("data-alloc", JSON.stringify(allocMap(firstVar)));
    }
    if (!plans.length) {
      if (add && !add.disabled) {
        add.disabled = true;
        add.textContent = "Autoship not available";
      }
      paintCardPrice(card);
      return;
    }
    var plan = pickSixtyPlan(plans);
    if (plan) {
      card.setAttribute("data-swapt-plan-id", String(plan.id));
      card.setAttribute("data-save-pct", String(planPct(plan)));
    }
    if (!card.querySelector(".swapt-card__cadence")) {
      var actions = card.querySelector(".swapt-card__actions");
      if (actions) actions.insertAdjacentHTML("beforebegin", planNoteHtml());
    }
    card.setAttribute("data-swapt-autoship", "true");
    if (add && !add.disabled) add.textContent = "Add to Cart";
    paintCardPrice(card);
  }

  function hydrateAutoshipCards(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-swapt-role="buy"][data-swapt-card]'));
    var pending = cards.filter(function (card) {
      return !card.getAttribute("data-swapt-plan-id");
    });
    cards.forEach(paintCardPrice);
    if (!pending.length) return Promise.resolve();
    var i = 0;
    function next() {
      var card = pending[i++];
      if (!card) return Promise.resolve();
      var handle = card.getAttribute("data-product-handle");
      if (!handle) return next();
      return fetch(PRODUCT_URL(handle), { credentials: "same-origin" })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (product) {
          if (product) injectAutoship(card, product);
          return next();
        })
        .catch(function () {
          return next();
        });
    }
    return Promise.all([next(), next(), next(), next()]);
  }

  function toIdSet(list) {
    var set = {};
    (list || []).forEach(function (id) {
      set[String(id)] = true;
    });
    return set;
  }

  function isSubLine(item) {
    return Boolean(item.selling_plan_allocation) || item.selling_plan != null;
  }

  function isGiftProp(item) {
    var props = item.properties || {};
    return props._swapt_gift === "1" || props["_swapt_gift"] === "1";
  }

  function lineQualifies(item, cfg) {
    if (isGiftProp(item)) return false;
    var pid = String(item.product_id);
    if (!cfg.buyXSet[pid]) return false;
    if (cfg.requirement === "subscription") return isSubLine(item);
    return !isSubLine(item);
  }

  function qualifyingCents(cart, cfg) {
    return (cart.items || []).reduce(function (sum, item) {
      if (!lineQualifies(item, cfg)) return sum;
      return sum + (item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function collectRoleIds(root, cfg, role, intoKey) {
    if (!root || !cfg || !cfg[intoKey]) return;
    root.querySelectorAll('[data-swapt-role="' + role + '"]').forEach(function (card) {
      var id = card.getAttribute("data-product-id");
      if (id) cfg[intoKey][String(id)] = true;
    });
  }

  function collectGiftIds(root, cfg) {
    collectRoleIds(root, cfg, "gift", "getYSet");
  }

  function collectBuyIds(root, cfg) {
    collectRoleIds(root, cfg, "buy", "buyXSet");
  }

  function giftLine(cart, cfg) {
    return (cart.items || []).find(function (item) {
      return !isSubLine(item) && isGiftProp(item);
    });
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        if (window.liquidAjaxCart && window.liquidAjaxCart.cart) {
          return window.liquidAjaxCart.cart;
        }
        return { items: [] };
      });
  }

  function mergeProductIds(into, products) {
    (products || []).forEach(function (p) {
      if (p && p.id) into[String(p.id)] = true;
    });
  }

  function fetchAllCollectionProducts(handle) {
    if (!handle) return Promise.resolve([]);
    function page(n, acc) {
      return fetch(COLLECTION_PRODUCTS_URL(handle, n), { credentials: "same-origin" })
        .then(function (r) {
          return r.ok ? r.json() : { products: [] };
        })
        .then(function (data) {
          var list = data.products || [];
          acc = acc.concat(list);
          if (list.length >= 250) return page(n + 1, acc);
          return acc;
        })
        .catch(function () {
          return acc;
        });
    }
    return page(1, []);
  }

  function applyDiscountFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var code = (params.get("discount") || "").trim();
    if (!code) return;
    fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" }).catch(function () {});
  }

  function hideBlockingCampaigns() {
    ["alia-root", "cst-shadow-host", "ps__widget"].forEach(function (id) {
      var exact = document.getElementById(id);
      if (exact) exact.setAttribute("hidden", "");
    });
    document.querySelectorAll('[id^="alia-root"]').forEach(function (el) {
      el.setAttribute("hidden", "");
    });
  }

  function watchBlockingCampaigns() {
    hideBlockingCampaigns();
    var tries = 0;
    var timer = setInterval(function () {
      hideBlockingCampaigns();
      tries += 1;
      if (tries >= 12) clearInterval(timer);
    }, 500);
    if (window.MutationObserver) {
      var obs = new MutationObserver(hideBlockingCampaigns);
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        obs.disconnect();
      }, 8000);
    }
  }

  function tagBlob(product) {
    if (Array.isArray(product.tags)) return product.tags.join(" ").toLowerCase();
    return String(product.tags || "").toLowerCase();
  }

  function filterKeysFor(product) {
    var ptype = String(product.product_type || "").toLowerCase();
    var phandle = String(product.handle || "").toLowerCase();
    var ptitle = String(product.title || "").toLowerCase();
    var blob = ptype + " " + phandle + " " + ptitle;
    var tags = tagBlob(product);
    var toolWord =
      blob.indexOf("brush") !== -1 ||
      blob.indexOf("mitt") !== -1 ||
      blob.indexOf("applicator") !== -1 ||
      blob.indexOf("kabuki") !== -1 ||
      blob.indexOf("sponge") !== -1 ||
      ptype.indexOf("tool") !== -1;
    var isFormula =
      ptitle.indexOf("lotion") !== -1 ||
      ptitle.indexOf("mousse") !== -1 ||
      ptitle.indexOf("serum") !== -1 ||
      ptitle.indexOf("wash") !== -1 ||
      ptitle.indexOf("cream") !== -1 ||
      ptitle.indexOf("drops") !== -1 ||
      ptitle.indexOf("mist") !== -1;
    var isTool = toolWord && !isFormula;
    var isBag =
      blob.indexOf("gift bag") !== -1 ||
      blob.indexOf("gift-bag") !== -1 ||
      blob.indexOf("pouch") !== -1 ||
      (ptitle.indexOf("bag") !== -1 && ptitle.indexOf("self tanner") === -1 && ptitle.indexOf("tanning") === -1);
    var isKit =
      ptitle.indexOf("kit") !== -1 ||
      ptitle.indexOf("bundle") !== -1 ||
      ptitle.indexOf("duo") !== -1 ||
      ptitle.indexOf("trio") !== -1 ||
      ptitle.indexOf("set") !== -1;
    var cat = "more";
    if (isTool) cat = "tools";
    else if (isBag) cat = "accessories";
    else if (ptype.indexOf("tanner") !== -1 || ptitle.indexOf("self tanner") !== -1 || ptitle.indexOf("tanning") !== -1)
      cat = "tanners";
    else if (ptype.indexOf("deodorant") !== -1) cat = "body";
    else if (ptitle.indexOf("shave") !== -1 || phandle.indexOf("shave") !== -1 || ptype.indexOf("shave") !== -1)
      cat = "body";
    else if (ptype.indexOf("hair") !== -1 || ptitle.indexOf("hair") !== -1) cat = "hair";
    else if (ptype.indexOf("sun") !== -1 || ptype.indexOf("spf") !== -1 || ptitle.indexOf("sunscreen") !== -1 || ptitle.indexOf("spf") !== -1)
      cat = "sun";
    else if (ptype.indexOf("body") !== -1 || ptype.indexOf("bath") !== -1 || ptitle.indexOf("body") !== -1) cat = "body";
    else if (ptitle.indexOf("face") !== -1 || ptitle.indexOf("facial") !== -1 || ptype.indexOf("face") !== -1) cat = "face";
    var keys = [cat];
    if (isKit && cat !== "tools" && cat !== "accessories") keys.push("kits");
    if (cat !== "face" && cat !== "tools" && cat !== "accessories") {
      if (ptitle.indexOf("face") !== -1 || ptitle.indexOf("facial") !== -1 || ptype.indexOf("face") !== -1) keys.push("face");
    }
    var sunHint =
      tags.indexOf("sunscreen") !== -1 ||
      tags.indexOf("spf") !== -1 ||
      ptype.indexOf("cooling") !== -1 ||
      ptype.indexOf("after-sun") !== -1 ||
      phandle.indexOf("aloe-vera") !== -1 ||
      phandle.indexOf("after-sun") !== -1 ||
      ptitle.indexOf("sunscreen") !== -1 ||
      ptitle.indexOf("spf") !== -1 ||
      ptitle.indexOf("after sun") !== -1;
    if (cat !== "sun" && sunHint) keys.push("sun");
    if (tags.indexOf("best-seller") !== -1 || tags.indexOf("popular") !== -1) keys.push("popular");
    var isNew = tags.indexOf("new-arrival") !== -1 || /(^|\s)new(\s|$)/.test(tags);
    if (!isNew && product.published_at) {
      var age = (Date.now() - new Date(product.published_at).getTime()) / 86400000;
      if (age <= 90) isNew = true;
    }
    if (isNew) keys.push("new");
    return keys.join(" ");
  }

  function merchGroupFromBlob(title, handle, filters, tags) {
    var blob = [title, handle, filters, tags]
      .map(function (part) {
        return String(part || "").toLowerCase();
      })
      .join(" ");
    var isTravel =
      /travel|mini\b|trial|\b2[\s-]?oz\b|\b0\.5\b/.test(blob);
    var isTanner = /self[\s-]?tann|tanning|\btanners\b/.test(blob);
    if (isTanner && !isTravel) return 0;
    if (/bath[\s-]?bomb/.test(blob)) return 1;
    if (/\bserum/.test(blob)) return 2;
    return 3;
  }

  function merchRank(card) {
    if (!card) return 3;
    var existing = card.getAttribute("data-swapt-merch");
    if (existing != null && existing !== "") return Number(existing);
    return merchGroupFromBlob(
      card.getAttribute("data-swapt-title"),
      card.getAttribute("data-product-handle"),
      card.getAttribute("data-swapt-filters"),
      ""
    );
  }

  var HIDDEN_HANDLES = {
    "gift-bag": true,
    "face-mask-brush-applicator": true,
    "foot-file": true,
    "pumice-stone": true,
  };

  function isHiddenProduct(product) {
    var handle = String((product && product.handle) || "").toLowerCase();
    return Boolean(HIDDEN_HANDLES[handle]);
  }

  function cardSortPrice(card) {
    if (!card) return 0;
    var otp = Number(card.getAttribute("data-otp-price") || 0);
    if (card.getAttribute("data-swapt-role") === "gift") return otp;
    var planId = card.getAttribute("data-swapt-plan-id");
    if (!planId) return otp;
    var alloc = parseAlloc(card.getAttribute("data-alloc"));
    if (alloc[String(planId)] != null) return Number(alloc[String(planId)]);
    var pct = Number(card.getAttribute("data-save-pct") || 0);
    if (pct > 0) return Math.round((otp * (100 - pct)) / 100);
    return otp;
  }

  function typeGroupRank(card) {
    if (!card) return 10;
    var title = String(card.getAttribute("data-swapt-title") || "").toLowerCase();
    var handle = String(card.getAttribute("data-product-handle") || "").toLowerCase();
    var filters = String(card.getAttribute("data-swapt-filters") || "").toLowerCase();
    var blob = title + " " + handle + " " + filters;
    if (/self[\s-]?tann|tanning|\btanners\b/.test(blob)) return 0;
    if (/\blip\b/.test(blob)) return 1;
    if (/face[\s-]?wash|foaming face|facial wash|face bar|cleanser|cleansing face/.test(blob)) return 2;
    if (/moistur|face cream|vitamin-c-cream|eye cream|eye gel|hyaluronic-acid-face-cream/.test(blob)) return 3;
    if (/\bface\b/.test(filters) || /face|facial/.test(blob)) return 4;
    if (/\bsun\b/.test(filters) || /sunscreen|spf|after[\s-]?sun/.test(blob)) return 5;
    if (/\bbody\b/.test(filters) || /body|bath|shower/.test(blob)) return 6;
    if (/\bhair\b/.test(filters) || /hair|shampoo|salt spray/.test(blob)) return 7;
    if (/\btools\b/.test(filters)) return 8;
    if (/accessories/.test(filters)) return 9;
    return 10;
  }

  function secondaryHoverImage(product, primarySrc) {
    var images = product.images || [];
    var primary = normalizeImg(primarySrc);
    function srcAt(i) {
      if (!images[i]) return "";
      return normalizeImg(images[i].src || images[i]);
    }
    var second = srcAt(1);
    if (second && second !== primary) return second;
    var third = srcAt(2);
    if (third && third !== primary) return third;
    return "";
  }

  function normalizeImg(src) {
    if (!src) return "";
    var out = String(src);
    return out.indexOf("//") === 0 ? "https:" + out : out;
  }

  function firstImage(product, variant) {
    if (variant && variant.featured_image) {
      return normalizeImg(variant.featured_image.src || variant.featured_image);
    }
    var title = String((variant && (variant.option1 || variant.title)) || "").toLowerCase();
    var images = product.images || [];
    if (title && title !== "default title") {
      var slug = title.replace(/\s+/g, "-");
      for (var i = 0; i < images.length; i++) {
        var alt = String(images[i].alt || "").toLowerCase();
        var src = String(images[i].src || images[i] || "").toLowerCase();
        if ((alt && (alt.indexOf(title) !== -1 || title.indexOf(alt) !== -1)) || src.indexOf(slug) !== -1) {
          return normalizeImg(images[i].src || images[i]);
        }
      }
    }
    if (images[0]) return normalizeImg(images[0].src || images[0]);
    return "";
  }

  function escapeHtml(str) {
    var d = document.createElement("div");
    d.textContent = str || "";
    return d.innerHTML;
  }

  function availableVariants(product) {
    return (product.variants || []).filter(function (v) {
      return v.available !== false;
    });
  }

  function buildCardLi(product, role, requirement) {
    if (isHiddenProduct(product)) return null;
    var variants = product.variants || [];
    var usable = availableVariants(product);
    if (!usable.length) return null;
    var variant = usable[0] || variants[0];
    if (!variant) return null;
    var inStock = usable.length > 0;
    var keys = filterKeysFor(product);
    var priceCents = toCents(variant.price);
    var compareCents = toCents(variant.compare_at_price);
    var img = firstImage(product, variant);
    var addLabel = "Add to Cart";
    if (requirement === "subscription" && role !== "gift" && !skioPlans(product).length) return null;
    var options = "";
    var hasOptions = variants.length > 1 || (variants[0] && variants[0].title !== "Default Title");
    if (hasOptions) {
      options =
        '<label class="visually-hidden" for="swapt-js-' +
        product.id +
        '">Variant</label><div class="swapt-card__select-wrap"><select id="swapt-js-' +
        product.id +
        '" class="swapt-card__select" data-swapt-variant-select' +
        (inStock ? "" : " disabled") +
        ">" +
        variants
          .map(function (v) {
            var ok = v.available !== false;
            var vimg = firstImage(product, v);
            return (
              '<option value="' +
              v.id +
              '" data-price="' +
              toCents(v.price) +
              '" data-compare="' +
              toCents(v.compare_at_price) +
              '" data-alloc="' +
              escapeHtml(JSON.stringify(allocMap(v))) +
              '" data-available="' +
              ok +
              '"' +
              (vimg
                ? ' data-image="' +
                  escapeHtml(vimg) +
                  '" data-srcset="' +
                  escapeHtml(vimg) +
                  ' 600w"'
                : "") +
              (v.id === variant.id ? " selected" : "") +
              (ok ? "" : " disabled") +
              ">" +
              escapeHtml(v.title) +
              (ok ? "" : " — Sold out") +
              "</option>"
            );
          })
          .join("") +
        '</select><svg class="swapt-card__select-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M5 9l7 7 7-7"/></svg></div>';
    }
    var li = document.createElement("li");
    li.className = "swapt-bogo__card";
    li.setAttribute("data-swapt-card-wrap", "");
    li.innerHTML =
      '<article class="swapt-card' +
      (inStock ? "" : " swapt-card--oos") +
      '" data-swapt-card data-swapt-role="' +
      role +
      '" data-swapt-filters="' +
      escapeHtml(keys) +
      '" data-swapt-merch="' +
      merchGroupFromBlob(product.title, product.handle, keys, tagBlob(product)) +
      '" data-swapt-title="' +
      escapeHtml(product.title) +
      '" data-product-id="' +
      product.id +
      '" data-product-handle="' +
      escapeHtml(product.handle) +
      '" data-default-variant-id="' +
      variant.id +
      '" data-available="' +
      inStock +
      '" data-otp-price="' +
      priceCents +
      '" data-alloc="' +
      escapeHtml(JSON.stringify(allocMap(variant))) +
      '"' +
      (requirement === "subscription" && role !== "gift" ? ' data-swapt-autoship="true"' : "") +
      (function () {
        var plan = requirement === "subscription" && role !== "gift" ? pickSixtyPlan(skioPlans(product)) : null;
        return plan
          ? ' data-swapt-plan-id="' +
              plan.id +
              '" data-save-pct="' +
              planPct(plan) +
              '"'
          : "";
      })() +
      ' data-compare-at="' +
      compareCents +
      '"><div class="swapt-card__media">' +
      (img
        ? '<img class="swapt-card__img" data-swapt-card-img src="' +
          escapeHtml(img) +
          '" alt="' +
          escapeHtml(product.title) +
          '" loading="lazy" width="400" height="400">' +
          (function () {
            var hover = secondaryHoverImage(product, img);
            return hover
              ? '<img class="swapt-card__img swapt-card__img--hover" src="' +
                  escapeHtml(hover) +
                  '" alt="" width="400" height="400" loading="lazy" aria-hidden="true">'
              : "";
          })()
        : '<div class="swapt-card__img swapt-card__img--empty" aria-hidden="true"></div>') +
      '</div><div class="swapt-card__body"><div class="swapt-card__rating"><div class="jdgm-widget jdgm-preview-badge swapt-card__jdgm" data-id="' +
      product.id +
      '" data-auto-install="false"></div><span class="swapt-card__rating-spacer" aria-hidden="true"></span></div><h3 class="swapt-card__title">' +
      escapeHtml(product.title) +
      '</h3><div class="swapt-card__price-row"><span class="swapt-card__compare" data-swapt-card-compare' +
      (compareCents > priceCents ? "" : " hidden") +
      ">" +
      (compareCents > priceCents ? formatMoney(compareCents) : "") +
      '</span><span class="swapt-card__price" data-swapt-card-price>' +
      formatMoney(priceCents) +
      '</span><span class="swapt-card__save" data-swapt-card-save hidden></span></div>' +
      options +
      (requirement === "subscription" && role !== "gift" ? planNoteHtml() : "") +
      '<div class="swapt-card__actions"><button type="button" class="swapt-card__add" data-swapt-ajax-atc' +
      (inStock ? "" : " disabled") +
      ">" +
      (inStock ? addLabel : "Sold out") +
      "</button>" +
      qtyHtml() +
      "</div></div></article>";
    return li;
  }

  function existingIds(gridWrap) {
    var ids = {};
    gridWrap.querySelectorAll("[data-swapt-card]").forEach(function (card) {
      ids[String(card.getAttribute("data-product-id"))] = true;
    });
    return ids;
  }

  function updateChipCounts(gridWrap) {
    var counts = {
      all: 0,
      new: 0,
      popular: 0,
      tanners: 0,
      face: 0,
      body: 0,
      sun: 0,
      hair: 0,
      tools: 0,
      kits: 0,
      accessories: 0,
    };
    gridWrap.querySelectorAll("[data-swapt-card]").forEach(function (card) {
      counts.all += 1;
      (card.getAttribute("data-swapt-filters") || "").split(/\s+/).forEach(function (key) {
        if (counts[key] != null) counts[key] += 1;
      });
    });
    Object.keys(counts).forEach(function (key) {
      var el = gridWrap.querySelector('[data-swapt-chip-count="' + key + '"]');
      if (el) el.textContent = String(counts[key]);
      var chip = gridWrap.querySelector('[data-swapt-filter="' + key + '"]');
      if (chip && key !== "all") chip.hidden = counts[key] < 1;
    });
  }

  function sortGrid(list, role) {
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    items.sort(function (a, b) {
      var ca = a.querySelector("[data-swapt-card]");
      var cb = b.querySelector("[data-swapt-card]");
      var pa = cardSortPrice(ca);
      var pb = cardSortPrice(cb);
      if (pa !== pb) return role === "gift" ? pa - pb : pb - pa;
      var ta = typeGroupRank(ca);
      var tb = typeGroupRank(cb);
      if (ta !== tb) return ta - tb;
      var ga = merchRank(ca);
      var gb = merchRank(cb);
      if (ga !== gb) return ga - gb;
      return 0;
    });
    items.forEach(function (li) {
      list.appendChild(li);
    });
  }

  function appendMissingProducts(gridWrap, products, role, requirement) {
    var list = gridWrap.querySelector("[data-swapt-card-list]");
    if (!list) return;
    var have = existingIds(gridWrap);
    products.forEach(function (product) {
      if (!product || have[String(product.id)]) return;
      var li = buildCardLi(product, role, requirement);
      if (li) list.appendChild(li);
    });
    sortGrid(list, role);
    updateChipCounts(gridWrap);
    applySelectedImages(gridWrap);
    applyReviewStars(gridWrap.closest("[data-swapt-bogo]") || document);
    refreshJudgeme();
    gridWrap.querySelectorAll("[data-swapt-card]").forEach(paintCardPrice);
    var note = gridWrap.querySelector("[data-swapt-more-note]");
    if (note) {
      var n = gridWrap.querySelectorAll("[data-swapt-card]").length;
      note.textContent = n ? "Showing all " + n + " products." : "";
      note.hidden = n < 1;
    }
  }

  function fetchProductJs(handle, attempt) {
    if (!handle) return Promise.resolve(null);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) {
        if (r.ok) return r.json();
        if ((attempt || 0) < 2) {
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(fetchProductJs(handle, (attempt || 0) + 1));
            }, 250 * ((attempt || 0) + 1));
          });
        }
        return null;
      })
      .catch(function () {
        if ((attempt || 0) < 2) {
          return fetchProductJs(handle, (attempt || 0) + 1);
        }
        return null;
      });
  }

  function appendMissingWithPlans(gridWrap, products, role, requirement) {
    if (!gridWrap) return Promise.resolve();
    if (requirement !== "subscription" || role === "gift") {
      appendMissingProducts(gridWrap, products, role, requirement);
      return Promise.resolve();
    }
    var have = existingIds(gridWrap);
    var missing = (products || []).filter(function (product) {
      return product && !have[String(product.id)];
    });
    var hydrated = [];
    var i = 0;
    function next() {
      var product = missing[i++];
      if (!product) return Promise.resolve();
      if (skioPlans(product).length) {
        hydrated.push(product);
        return next();
      }
      return fetchProductJs(product.handle).then(function (full) {
        if (full) hydrated.push(full);
        return next();
      });
    }
    return Promise.all([next(), next(), next()]).then(function () {
      appendMissingProducts(gridWrap, hydrated, role, requirement);
    });
  }

  function applyOptionImage(img, opt) {
    if (!img || !opt) return;
    var next = opt.getAttribute("data-image");
    var srcset = opt.getAttribute("data-srcset");
    if (!next) return;
    img.src = next;
    if (srcset) img.setAttribute("srcset", srcset);
    else img.removeAttribute("srcset");
  }

  function applySelectedImages(scope) {
    (scope || document).querySelectorAll("[data-swapt-variant-select]").forEach(function (select) {
      var opt = select.selectedOptions[0];
      var card = select.closest("[data-swapt-card]");
      if (!opt || !card) return;
      var img = card.querySelector("[data-swapt-card-img], img.swapt-card__img");
      applyOptionImage(img, opt);
    });
  }

  function bindVariantUi(root) {
    applySelectedImages(root);
    root.querySelectorAll("[data-swapt-card]").forEach(paintCardPrice);
    root.addEventListener("change", function (e) {
      var variantSelect = e.target.closest("[data-swapt-variant-select]");
      var planSelect = e.target.closest("[data-swapt-plan-select]");
      if ((!variantSelect && !planSelect) || !root.contains(e.target)) return;
      var card = e.target.closest("[data-swapt-card]");
      if (!card) return;
      if (variantSelect) {
        var opt = variantSelect.selectedOptions[0];
        if (!opt) return;
        var img = card.querySelector("[data-swapt-card-img], .swapt-card__img");
        var add = card.querySelector("[data-swapt-ajax-atc]");
        var ok = opt.getAttribute("data-available") !== "false";
        applyOptionImage(img, opt);
        card.setAttribute("data-default-variant-id", opt.value);
        card.setAttribute("data-otp-price", opt.getAttribute("data-price") || "");
        if (opt.getAttribute("data-alloc")) card.setAttribute("data-alloc", opt.getAttribute("data-alloc"));
        if (add && add.getAttribute("data-swapt-orig") !== "sold" && add.textContent.trim() !== "Autoship not available") {
          add.disabled = !ok;
        }
      }
      paintCardPrice(card);
    });
  }

  function selectedVariantId(card) {
    var select = card.querySelector("[data-swapt-variant-select]");
    if (select && select.value) return select.value;
    return card.getAttribute("data-default-variant-id");
  }

  function addLine(payload, done, silent) {
    var opts = {
      lastCallback: function () {
        if (done) done();
      },
    };
    if (silent) opts.info = { should_keep_drawer_closed: true };
    if (window.liquidAjaxCart && window.liquidAjaxCart.add) {
      window.liquidAjaxCart.add(payload, opts);
      return;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    }).finally(function () {
      if (done) done();
    });
  }

  function openCartDrawer() {
    function reveal(drawer) {
      if (!drawer) return false;
      delete drawer.dataset.userClosed;
      drawer.removeAttribute("data-user-closed");
      drawer.removeAttribute("closing");
      if (typeof drawer.open === "function") drawer.open();
      else drawer.setAttribute("open", "");
      return true;
    }
    var drawer = document.querySelector("cart-drawer");
    if (reveal(drawer)) return;
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("cart-drawer").then(function () {
        reveal(document.querySelector("cart-drawer"));
      });
    }
    var trigger = document.querySelector("[data-cart-drawer-trigger], #cart-icon-bubble, .header__icon--cart");
    if (trigger) trigger.click();
  }

  function lockGiftUi(root) {
    root.setAttribute("data-swapt-state", "ready");
    applyDockCta(root);
  }

  var reviewMap = {};

  function starIconSvg() {
    return '<svg class="swapt-card__star-icon" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2.4l2.7 6.3 6.8.6-5.2 4.5 1.6 6.6L12 16.9 6.1 20.4l1.6-6.6-5.2-4.5 6.8-.6L12 2.4z"/></svg>';
  }

  function applyReviewStars(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll("[data-swapt-card]").forEach(function (card) {
      if (card.querySelector(".swapt-card__stars")) return;
      var review = reviewMap[String(card.getAttribute("data-product-id") || "")];
      if (!review || !(review.avg > 0) || !(review.count > 0)) return;
      var rating = card.querySelector(".swapt-card__rating");
      if (!rating) return;
      var pct = Math.max(0, Math.min(100, (Number(review.avg) / 5) * 100));
      var countLabel = String(review.count);
      if (review.count >= 1000) {
        countLabel = Math.floor(review.count / 1000) + "," + String(review.count % 1000).padStart(3, "0");
      }
      var icons = starIconSvg() + starIconSvg() + starIconSvg() + starIconSvg() + starIconSvg();
      rating.innerHTML =
        '<span class="swapt-card__stars" role="img" aria-label="Rated ' +
        Number(review.avg).toFixed(1) +
        " out of 5 stars, " +
        countLabel +
        ' reviews"><span class="swapt-card__stars-base" aria-hidden="true">' +
        icons +
        '</span><span class="swapt-card__stars-fill" style="width:' +
        pct +
        '%" aria-hidden="true">' +
        icons +
        '</span></span><span class="swapt-card__reviews" aria-hidden="true">(' +
        countLabel +
        ")</span>";
    });
  }

  function loadReviewMap(root) {
    var url = root.getAttribute("data-swapt-reviews-url");
    if (!url) return Promise.resolve();
    return fetch(url)
      .then(function (res) {
        return res.ok ? res.json() : {};
      })
      .then(function (map) {
        reviewMap = map || {};
        applyReviewStars(root);
      })
      .catch(function () {});
  }

  function refreshJudgeme() {
    try {
      if (window.jdgm && typeof window.jdgm.customizeBadges === "function") {
        window.jdgm.customizeBadges();
        return;
      }
    } catch (e) {}
    document.dispatchEvent(new Event("jdgm:refresh"));
  }

  function placeHowToInHero() {
    var icon = document.querySelector('[class*="collection-banner-info-icon"]');
    if (!icon) return;
    var content = icon.closest('[class*="collection-banner-content"]');
    var banner = content && content.parentElement;
    if (!banner) return;
    icon.classList.add("swapt-howto-icon");
    if (icon.parentElement !== banner) banner.appendChild(icon);
    document.querySelectorAll('[class*="collection-banner-info-line"]').forEach(function (line) {
      line.hidden = true;
    });
    if (icon.dataset.swaptHowToBound === "1") return;
    icon.dataset.swaptHowToBound = "1";
    if (!icon.hasAttribute("tabindex")) icon.setAttribute("tabindex", "0");
    if (!icon.getAttribute("role") || icon.getAttribute("role") === "img") {
      icon.setAttribute("role", "button");
    }
    icon.setAttribute("aria-expanded", "false");
    function toggleHowTo(open) {
      var next = typeof open === "boolean" ? open : !icon.classList.contains("is-open");
      icon.classList.toggle("is-open", next);
      icon.setAttribute("aria-expanded", next ? "true" : "false");
    }
    icon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleHowTo();
    });
    icon.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleHowTo();
      }
      if (e.key === "Escape") toggleHowTo(false);
    });
    document.addEventListener("click", function (e) {
      if (!icon.contains(e.target)) toggleHowTo(false);
    });
  }

  function removeHiddenCards(scope) {
    (scope || document).querySelectorAll("[data-swapt-card]").forEach(function (card) {
      var handle = String(card.getAttribute("data-product-handle") || "").toLowerCase();
      if (!HIDDEN_HANDLES[handle]) return;
      var wrap = card.closest("[data-swapt-card-wrap]") || card;
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    });
  }

  function initRoot(root) {
    var cfg = parseConfig(root);
    removeHiddenCards(root);
    cfg.threshold = Number(cfg.threshold) || 35;
    cfg.thresholdCents = Math.round(cfg.threshold * 100);
    cfg.requirement = cfg.requirement === "subscription" ? "subscription" : "one_time";
    try {
      var reqParam = new URLSearchParams(window.location.search).get("swapt_req");
      if (reqParam === "subscription" || reqParam === "one_time") cfg.requirement = reqParam;
    } catch (e) {}
    if (cfg.requirement === "subscription") {
      root.setAttribute(
        "data-step1-sub",
        "Add $" + cfg.threshold + "+ in Autoship products to unlock your free gift."
      );
      root.setAttribute(
        "data-step2-sub",
        "Choose 1 additional item as a one-time purchase. The lowest-valued item will be free at checkout."
      );
    } else {
      root.setAttribute("data-step1-sub", "Add $" + cfg.threshold + "+ to unlock your free gift.");
      root.setAttribute(
        "data-step2-sub",
        "Choose 1 additional item. The lowest-valued item will be free at checkout."
      );
    }
    var liveSub = root.querySelector("[data-swapt-step-sub]");
    if (liveSub) liveSub.textContent = root.getAttribute("data-step1-sub");
    if (cfg.requirement === "subscription") {
      root.querySelectorAll('[data-swapt-role="buy"] [data-swapt-ajax-atc]').forEach(function (btn) {
        if (!btn.disabled) btn.textContent = "Add to Cart";
      });
    }
    cfg.buyXHandle = cfg.buyXHandle || "swapt-buy-x-eligible-products";
    cfg.getYHandle = cfg.getYHandle || "swapt-get-y-eligible-products";
    cfg.buyXSet = toIdSet(cfg.buyXIds);
    cfg.getYSet = toIdSet(cfg.getYIds);

    var buyGridEarly = root.querySelector('[data-swapt-grid][data-role="buy"]');
    var giftGridEarly = root.querySelector('[data-swapt-grid][data-role="gift"]');
    if (buyGridEarly) sortGrid(buyGridEarly.querySelector("[data-swapt-card-list]"), "buy");
    if (giftGridEarly) sortGrid(giftGridEarly.querySelector("[data-swapt-card-list]"), "gift");

    var progresses = root.querySelectorAll("[data-swapt-progress]");
    var fills = root.querySelectorAll("[data-swapt-progress-fill]");
    var copyEls = root.querySelectorAll("[data-swapt-progress-copy]");
    var spentEls = root.querySelectorAll("[data-swapt-progress-spent]");
    var giftRegion = root.querySelector("[data-swapt-gift-region]");
    var giftStatus = root.querySelector("[data-swapt-gift-status]");
    var stepBtns = root.querySelectorAll("[data-swapt-step-tab]");
    var dockSpent = root.querySelector("[data-swapt-dock-spent]");
    var dockSub = root.querySelector("[data-swapt-dock-sub]");
    var dockCta = root.querySelector("[data-swapt-dock-cta]");
    var lastState = "";

    Promise.all([
      fetchAllCollectionProducts(cfg.buyXHandle),
      fetchAllCollectionProducts(cfg.getYHandle),
    ]).then(function (results) {
      mergeProductIds(cfg.buyXSet, results[0]);
      mergeProductIds(cfg.getYSet, results[1]);
      collectBuyIds(root, cfg);
      refresh();
      var buyGrid = root.querySelector('[data-swapt-grid][data-role="buy"]');
      var giftGrid = root.querySelector('[data-swapt-grid][data-role="gift"]');
      if (giftGrid) {
        sortGrid(giftGrid.querySelector("[data-swapt-card-list]"), "gift");
        appendMissingProducts(giftGrid, results[1], "gift", cfg.requirement);
      }
      var extraBuy = buyGrid
        ? appendMissingWithPlans(buyGrid, results[0], "buy", cfg.requirement)
        : Promise.resolve();
      extraBuy.then(function () {
        removeHiddenCards(root);
        if (buyGrid) sortGrid(buyGrid.querySelector("[data-swapt-card-list]"), "buy");
        collectBuyIds(root, cfg);
        collectGiftIds(root, cfg);
        var buyFallback = root.querySelector("[data-swapt-buy-fallback]");
        if (buyFallback) buyFallback.hidden = !!(buyGrid && buyGrid.querySelector("[data-swapt-card]"));
        if (giftGrid && !giftGrid.querySelector("[data-swapt-card]")) {
          var empty = giftGrid.querySelector("[data-swapt-empty]");
          if (empty) {
            empty.hidden = false;
            empty.textContent = "Free gifts are loading. If this stays empty, the gift collection is not published to the storefront yet.";
          }
        }
        var ready = cfg.requirement === "subscription" ? hydrateAutoshipCards(root) : Promise.resolve();
        ready.then(function () {
          if (buyGrid) sortGrid(buyGrid.querySelector("[data-swapt-card-list]"), "buy");
          refresh();
        });
      });
    });

    function showPanel(step) {
      goToStep(root, step);
    }

    function setState(state, remainingCents, spentCents) {
      root.setAttribute("data-swapt-state", state);
      syncBack(root);
      root.dataset.swaptUnlocked = state === "locked" ? "false" : "true";
      root.dataset.swaptGiftAdded = state === "ready" ? "true" : "false";
      var spent = formatMoney(spentCents || 0);
      var label = "Gift progress, " + spent + " of " + formatMoney(cfg.thresholdCents);
      progresses.forEach(function (progress) {
        progress.setAttribute("data-state", state);
        progress.setAttribute("aria-label", label);
      });
      if (giftRegion) {
        giftRegion.classList.toggle("is-locked", state === "locked");
        giftRegion.classList.toggle("is-taken", state === "ready");
        giftRegion.setAttribute("aria-disabled", state === "locked" ? "true" : "false");
      }
      var remaining = formatMoney(remainingCents);
      spentEls.forEach(function (el) {
        el.textContent = spent;
      });
      if (dockSpent) dockSpent.textContent = spent;
      var copies = {
        locked: {
          copy: remaining + " to go",
          gift: "Unlocks at $" + cfg.threshold,
          dockSub: remaining + " to unlock your gift",
          cta: "Add " + remaining + " More",
          waiting: true,
          checkout: false,
        },
        unlocked: {
          copy: "Gift unlocked",
          gift: "Pick 1 free gift",
          dockSub: "Your gift is unlocked",
          cta: "Pick Free Gift",
          waiting: false,
          checkout: false,
        },
        ready: {
          copy: "GIFT ADDED ✓",
          gift: "One free gift selected",
          dockSub: "One gift per order",
          cta: "CHECKOUT",
          waiting: false,
          checkout: true,
          step1Cta: "Pick Free Gift",
        },
      };
      var pack = copies[state] || copies.locked;
      copyEls.forEach(function (el) {
        el.textContent = pack.copy;
      });
      if (giftStatus) giftStatus.textContent = pack.gift;
      root._swaptDock = {
        state: state,
        remaining: remaining,
        locked: copies.locked,
        unlocked: copies.unlocked,
        ready: copies.ready,
      };
      applyDockCta(root);
      paintCompleteHead(root);
      stepBtns.forEach(function (btn) {
        var step = btn.getAttribute("data-swapt-step-tab");
        btn.classList.toggle("is-done", state !== "locked" && step === "1");
        if (step === "2") {
          var locked = state === "locked";
          btn.setAttribute("aria-disabled", locked ? "true" : "false");
        }
      });
      if (state === "unlocked" && lastState === "locked") showPanel(2);
      if (state === "ready" && lastState !== "ready") {
        root.removeAttribute("data-swapt-review");
        goToStep(root, "2", { skipScroll: true });
      }
      if (state === "locked" && lastState && lastState !== "locked") {
        root.removeAttribute("data-swapt-review");
        goToStep(root, "1", { skipScroll: true });
      }
      lastState = state;
      root.querySelectorAll("[data-swapt-role='gift'] [data-swapt-ajax-atc]").forEach(function (btn) {
        if (btn.classList.contains("is-loading")) return;
        var oos = Boolean(btn.closest(".swapt-card--oos"));
        var lock = state === "locked";
        btn.disabled = lock || oos;
        btn.classList.toggle("is-gift-locked", lock);
        btn.setAttribute("aria-disabled", lock || oos ? "true" : "false");
        if (!lock && !oos) btn.textContent = btn.dataset.swaptLabel || "Add to Cart";
      });
      if (root._swaptPaintPicks) root._swaptPaintPicks();
    }

    function refresh() {
      getCart()
        .then(function (cart) {
          collectBuyIds(root, cfg);
          collectGiftIds(root, cfg);
          var spent = qualifyingCents(cart, cfg);
          var gift = giftLine(cart, cfg);
          var remaining = Math.max(0, cfg.thresholdCents - spent);
          var pct = Math.max(0, Math.min(100, (spent / cfg.thresholdCents) * 100));
          if (gift || spent >= cfg.thresholdCents) pct = 100;
          fills.forEach(function (fill) {
            fill.style.width = pct + "%";
          });
          root.querySelectorAll("[data-swapt-progress-marker]").forEach(function (marker) {
            marker.style.left = pct + "%";
            var tip = marker.querySelector("[data-swapt-progress-tip]");
            if (!tip) return;
            if (pct < 8) {
              tip.style.left = "0";
              tip.style.transform = "translateX(0)";
            } else if (pct > 92) {
              tip.style.left = "100%";
              tip.style.transform = "translateX(-100%)";
            } else {
              tip.style.left = "50%";
              tip.style.transform = "translateX(-50%)";
            }
          });
          root.querySelectorAll("[data-swapt-progress-tip]").forEach(function (tip) {
            tip.textContent = formatMoney(spent);
          });
          syncCardQty(root, cart, cfg);
          root._swaptLastCart = cart;
          if (gift) {
            root.dataset.swaptGiftAdding = "";
            setState("ready", 0, spent);
          } else {
            root.dataset.swaptGiftAdding = "";
            if (spent >= cfg.thresholdCents) setState("unlocked", 0, spent);
            else setState("locked", remaining, spent);
          }
        })
        .catch(function () {
          setState("locked", cfg.thresholdCents, 0);
        });
    }

    document.addEventListener("liquid-ajax-cart:request-end", refresh);
    document.addEventListener("cart:updated", refresh);
    document.addEventListener("cart:refresh", refresh);
    var drawerEl = document.querySelector("cart-drawer");
    if (drawerEl && !drawerEl.dataset.swaptGiftWatch) {
      drawerEl.dataset.swaptGiftWatch = "1";
      var closeObs = new MutationObserver(function () {
        if (!drawerEl.hasAttribute("open")) refresh();
      });
      closeObs.observe(drawerEl, { attributes: true, attributeFilter: ["open"] });
    }

    collectBuyIds(root, cfg);
    collectGiftIds(root, cfg);
    bindFilters(root);
    bindCols(root);
    bindDock(root);
    loadReviewMap(root);
    bindPicks(root, cfg);
    bindQty(root, cfg);
    bindBack(root);
    bindCollectionLogo(root);
    bindShadeSelect(root);
    bindVariantUi(root);
    bindAtcIntercept(root, cfg);
    placeHowToInHero();
    refresh();
  }

  function headerCtaEl() {
    return document.querySelector(".lp-ec-aca-header__cta");
  }

  function applyDockCta(root) {
    var cta = root.querySelector("[data-swapt-dock-cta]");
    var sub = root.querySelector("[data-swapt-dock-sub]");
    var dock = root._swaptDock || {};
    var state = root.getAttribute("data-swapt-state") || "locked";
    var step = root.getAttribute("data-swapt-ui-step") || "1";
    var pack = dock[state] || dock.locked;
    if (step === "1") pack = state === "locked" ? dock.locked : dock.unlocked;
    if (!pack) return;
    if (sub) sub.textContent = pack.dockSub;
    var checkout = Boolean(pack.checkout) && step === "2";
    if (cta) {
      cta.textContent = checkout ? "CHECKOUT NOW" : pack.cta;
      cta.classList.toggle("is-waiting", Boolean(pack.waiting));
      cta.classList.toggle("is-checkout", checkout);
    }
    var header = headerCtaEl();
    if (header) {
      var label = header.querySelector(".lp-btn-text") || header;
      label.textContent = checkout ? "CHECKOUT" : pack.cta;
      header.classList.toggle("is-waiting", Boolean(pack.waiting));
      header.classList.toggle("is-checkout", checkout);
    }
  }

  function paintCompleteHead(root) {
    var step = root.getAttribute("data-swapt-ui-step") || "1";
    var review = root.getAttribute("data-swapt-review") === "1";
    var complete = root.getAttribute("data-swapt-state") === "ready" && step === "2" && !review;
    root.setAttribute("data-swapt-complete", complete ? "1" : "0");
    var item = root.querySelector('[data-swapt-step-item="2"]');
    if (!item) return;
    var num = item.querySelector(".swapt-bogo__step-num");
    var label = item.querySelector(".swapt-bogo__step-label");
    var sub = root.querySelector("[data-swapt-step-sub]");
    if (num) num.textContent = complete ? "✓" : "2";
    if (label) {
      label.textContent = complete
        ? root.getAttribute("data-step2-complete-title") || "You're ready to checkout."
        : "Pick your free gift.";
    }
    if (sub && step === "2") {
      sub.textContent = complete
        ? root.getAttribute("data-step2-complete-sub") ||
          "Your free gift is added. Your discount will apply automatically at checkout."
        : root.getAttribute("data-step2-sub") || "";
    }
  }

  function syncBack(root) {
    var back = root.querySelector("[data-swapt-back]");
    if (!back) return;
    back.hidden = root.getAttribute("data-swapt-ui-step") !== "2";
  }

  function paintStepHead(root, step) {
    var prefix = String(step) === "2" ? "step2" : "step1";
    root.setAttribute("data-swapt-ui-step", String(step));
    var sub = root.querySelector("[data-swapt-step-sub]");
    if (sub) sub.textContent = root.getAttribute("data-" + prefix + "-sub") || "";
    root.querySelectorAll("[data-swapt-step-item]").forEach(function (item) {
      var key = item.getAttribute("data-swapt-step-item");
      item.classList.toggle("is-active", key === String(step));
      item.classList.toggle("is-done", String(step) === "2" && key === "1");
    });
    syncBack(root);
    paintCompleteHead(root);
    applyDockCta(root);
    fitMobileBack(root);
  }

  function fitMobileBack(root) {
    var back = root.querySelector("[data-swapt-back]");
    if (!back) return;
    back.classList.remove("is-icon-only");
    if (window.innerWidth > 749 || back.hidden) return;
    var title = root.querySelector(".swapt-bogo__step.is-active");
    if (!title) return;
    var backRight = back.getBoundingClientRect().right;
    var titleLeft = title.getBoundingClientRect().left;
    if (backRight > titleLeft - 6) back.classList.add("is-icon-only");
  }

  function bindBack(root) {
    var back = root.querySelector("[data-swapt-back]");
    if (!back) return;
    back.addEventListener("click", function () {
      var step = root.getAttribute("data-swapt-ui-step") || "1";
      var complete = root.getAttribute("data-swapt-complete") === "1";
      if (step === "2" && complete) {
        root.setAttribute("data-swapt-review", "1");
        goToStep(root, "2", { skipScroll: true });
        return;
      }
      root.removeAttribute("data-swapt-review");
      goToStep(root, "1");
    });
    if (!root.dataset.swaptBackFit) {
      root.dataset.swaptBackFit = "1";
      window.addEventListener("resize", function () {
        fitMobileBack(root);
      });
    }
  }

  function bindCollectionLogo(root) {
    if (!root || root.dataset.swaptLogoStay === "1") return;
    root.dataset.swaptLogoStay = "1";
    var stayPath = window.location.pathname || "/";
    var logos = document.querySelectorAll(
      "a.lp-ec-aca-header__logo, a.header-nav-center-menu__logo-link, a.header__heading-link"
    );
    logos.forEach(function (logo) {
      if (!logo || logo.dataset.swaptLogoStay === "1") return;
      logo.dataset.swaptLogoStay = "1";
      logo.setAttribute("href", stayPath);
      logo.addEventListener("click", function (e) {
        if (e.defaultPrevented) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
      });
    });
  }

  function syncCardQty(root, cart) {
    root.querySelectorAll("[data-swapt-card]").forEach(function (card) {
      var role = card.getAttribute("data-swapt-role");
      var pid = String(card.getAttribute("data-product-id") || "");
      var lines = (cart.items || []).filter(function (item) {
        if (String(item.product_id) !== pid) return false;
        if (role === "gift") return isGiftProp(item);
        return !isGiftProp(item);
      });
      var qty = lines.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
      card.dataset.swaptLineKey = (lines[0] && lines[0].key) || "";
      var qtyWrap = card.querySelector("[data-swapt-qty]");
      var add = card.querySelector("[data-swapt-ajax-atc]");
      var val = card.querySelector("[data-swapt-qty-val]");
      card.classList.toggle("is-selected", qty > 0);
      if (qtyWrap) {
        qtyWrap.hidden = qty < 1;
        qtyWrap.classList.toggle("is-on", qty > 0);
      }
      if (val) val.textContent = String(qty);
      if (add) add.hidden = qty > 0;
      var inc = card.querySelector("[data-swapt-qty-inc]");
      if (inc) inc.disabled = role === "gift";
    });
    root.querySelectorAll("[data-swapt-grid]").forEach(syncPicksChip);
  }

  function bindQty(root, cfg) {
    root.addEventListener("click", function (e) {
      var dec = e.target.closest("[data-swapt-qty-dec]");
      var inc = e.target.closest("[data-swapt-qty-inc]");
      if ((!dec && !inc) || !root.contains(e.target)) return;
      var card = e.target.closest("[data-swapt-card]");
      if (!card) return;
      var key = card.dataset.swaptLineKey;
      var valEl = card.querySelector("[data-swapt-qty-val]");
      var qty = Number((valEl && valEl.textContent) || 0);
      if (inc) {
        if (card.getAttribute("data-swapt-role") === "gift") return;
        if (key) {
          setLoading(inc, true);
          changeLineQty(key, qty + 1, function () {
            setLoading(inc, false);
          });
          return;
        }
        var add = card.querySelector("[data-swapt-ajax-atc]");
        if (add) add.click();
        return;
      }
      if (dec) {
        setLoading(dec, true);
        changeLineQty(key, Math.max(0, qty - 1), function () {
          setLoading(dec, false);
        });
      }
    });
  }

  function goToStep(root, step, opts) {
    if (step === "2" && root.getAttribute("data-swapt-state") === "locked") return false;
    root.querySelectorAll("[data-swapt-panel]").forEach(function (panel) {
      panel.classList.toggle("is-active", panel.getAttribute("data-swapt-panel") === String(step));
    });
    paintStepHead(root, step);
    if (!opts || !opts.skipScroll) {
      var pin = root.querySelector("[data-swapt-pin]");
      if (pin) pin.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return true;
  }

  function bindSteps(root) {
    root.querySelectorAll("[data-swapt-step-tab]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        goToStep(root, btn.getAttribute("data-swapt-step-tab"));
      });
    });
  }

  function changeLineQty(key, qty, done) {
    if (window.liquidAjaxCart && window.liquidAjaxCart.change) {
      window.liquidAjaxCart.change(
        { id: key, quantity: qty },
        { lastCallback: done || function () {} }
      );
      return;
    }
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: qty }),
    }).finally(function () {
      if (done) done();
    });
  }

  function pickItems(cart, cfg) {
    return (cart.items || []).filter(function (item) {
      return lineQualifies(item, cfg) || isGiftProp(item);
    });
  }

  function shortTitle(name) {
    var text = String(name || "Item").replace(/\s+/g, " ").trim();
    if (text.length <= 28) return text;
    return text.slice(0, 26).replace(/\s+\S*$/, "") + "…";
  }

  function bindPicks(root, cfg) {
    var dockThumbs = root.querySelector("[data-swapt-dock-thumbs]");

    function paint() {
      var cart = root._swaptLastCart;
      var items = cart ? pickItems(cart, cfg) : [];
      if (!dockThumbs) return;
      var on = items.length > 0;
      var shown = items.slice(0, 4);
      var extra = items.length - shown.length;
      dockThumbs.innerHTML = shown
        .map(function (item, i) {
          var img = item.image ? normalizeImg(item.image) : "";
          var name = item.product_title || item.title || "Item";
          var badge =
            i === shown.length - 1 && extra > 0
              ? '<span class="swapt-bogo__dock-more">+' + extra + "</span>"
              : "";
          return (
            '<span class="swapt-bogo__dock-thumb">' +
            (img
              ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(name) + '">'
              : "<span>" + escapeHtml((name.charAt(0) || "?").toUpperCase()) + "</span>") +
            badge +
            "</span>"
          );
        })
        .join("");
      dockThumbs.hidden = !on;
      dockThumbs.classList.toggle("is-on", on);
    }

    root._swaptPaintPicks = paint;
  }

  function applyShadeToCards(root, shade) {
    shade = String(shade || "").toLowerCase();
    if (!shade) return;
    if (shade === "dark") shade = "medium";
    root.querySelectorAll("[data-swapt-variant-select]").forEach(function (select) {
      var match = [...select.options].find(function (opt) {
        return opt.textContent.toLowerCase().indexOf(shade) !== -1 && !opt.disabled;
      });
      if (!match) return;
      select.value = match.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function bindShadeSelect(root) {
    document.addEventListener("bbe:pdp-shade-quiz:select", function (e) {
      applyShadeToCards(root, (e.detail && (e.detail.tier || e.detail.shade)) || "");
    });
    document.addEventListener("bbe:shade-quiz:select", function (e) {
      applyShadeToCards(root, (e.detail && (e.detail.tier || e.detail.shade)) || "");
    });
    document.addEventListener("click", function (e) {
      var card = e.target.closest && e.target.closest("#shade_picker_modal .pdp-shade-finder__card");
      if (!card) return;
      applyShadeToCards(root, card.getAttribute("data-tier") || card.getAttribute("data-value") || "");
    });
  }

  function activateCta(root, source) {
    var state = root.getAttribute("data-swapt-state") || "locked";
    var step = root.getAttribute("data-swapt-ui-step") || "1";
    if (state === "ready" && step === "2") {
      setLoading(source, true);
      window.location.href = "/checkout";
      return;
    }
    if (state !== "locked") {
      goToStep(root, "2");
      return;
    }
    goToStep(root, "1");
    var grid = root.querySelector('[data-swapt-grid][data-role="buy"]');
    if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function bindDock(root) {
    var cta = root.querySelector("[data-swapt-dock-cta]");
    if (cta) {
      cta.addEventListener("click", function () {
        activateCta(root, cta);
      });
    }
    var header = headerCtaEl();
    if (!header || header.dataset.swaptCtaBound === "1") return;
    header.dataset.swaptCtaBound = "1";
    header.addEventListener("click", function (e) {
      e.preventDefault();
      activateCta(root, header);
    });
  }

  function bindCols(root) {
    var storageKey = "swapt-bogo-cols";
    function applyCols(cols) {
      var next = cols === "1" ? "1" : "2";
      try {
        window.sessionStorage.setItem(storageKey, next);
      } catch (e) {}
      root.querySelectorAll("[data-swapt-card-list]").forEach(function (list) {
        list.setAttribute("data-swapt-cols", next);
      });
      root.querySelectorAll("[data-swapt-cols-btn]").forEach(function (btn) {
        btn.setAttribute("aria-pressed", String(btn.getAttribute("data-swapt-cols-btn") === next));
      });
    }
    var saved = "2";
    try {
      saved = window.sessionStorage.getItem(storageKey) || "2";
    } catch (e) {}
    applyCols(saved);
    root.querySelectorAll("[data-swapt-cols-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        applyCols(btn.getAttribute("data-swapt-cols-btn") === "1" ? "1" : "2");
      });
    });
  }

  function bindFilters(root) {
    root.querySelectorAll("[data-swapt-grid]").forEach(function (gridWrap) {
      var chips = gridWrap.querySelectorAll("[data-swapt-filter]");
      var search = gridWrap.querySelector("[data-swapt-search]");
      var empty = gridWrap.querySelector("[data-swapt-empty]");
      var active = "all";

      function apply() {
        var q = (search && search.value ? search.value : "").trim().toLowerCase();
        var visible = 0;
        gridWrap.querySelectorAll("[data-swapt-card]").forEach(function (card) {
          var wrap = card.closest("[data-swapt-card-wrap]") || card;
          var keys = (card.getAttribute("data-swapt-filters") || "").split(/\s+/);
          var title = (card.getAttribute("data-swapt-title") || "").toLowerCase();
          var handle = (card.getAttribute("data-product-handle") || "").toLowerCase();
          var matchChip =
            active === "all" ||
            (active === "picks" ? card.classList.contains("is-selected") : keys.indexOf(active) !== -1);
          var matchSearch = !q || title.indexOf(q) !== -1 || handle.replace(/-/g, " ").indexOf(q) !== -1;
          var show = q ? matchSearch : matchChip;
          wrap.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) {
          empty.hidden = visible > 0;
          if (visible === 0 && !empty.textContent) empty.textContent = "No products in this filter.";
        }
      }

      chips.forEach(function (chip) {
        chip.addEventListener("click", function () {
          active = chip.getAttribute("data-swapt-filter") || "all";
          gridWrap._swaptFilterActive = active;
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle("is-selected", on);
            c.setAttribute("aria-pressed", on ? "true" : "false");
          });
          apply();
        });
      });
      if (search) search.addEventListener("input", apply);
      gridWrap._swaptApplyFilter = apply;
      gridWrap._swaptSetFilter = function (key) {
        active = key || "all";
        gridWrap._swaptFilterActive = active;
        chips.forEach(function (c) {
          var on = (c.getAttribute("data-swapt-filter") || "all") === active;
          c.classList.toggle("is-selected", on);
          c.setAttribute("aria-pressed", on ? "true" : "false");
        });
        apply();
      };
      syncPicksChip(gridWrap);
    });
  }

  function syncPicksChip(gridWrap) {
    if (!gridWrap) return;
    var chip = gridWrap.querySelector('[data-swapt-filter="picks"]');
    if (!chip) return;
    var n = gridWrap.querySelectorAll("[data-swapt-card].is-selected").length;
    var countEl = chip.querySelector('[data-swapt-chip-count="picks"]');
    if (countEl) countEl.textContent = String(n);
    chip.hidden = n < 1;
    if (n < 1 && gridWrap._swaptFilterActive === "picks") {
      if (gridWrap._swaptSetFilter) gridWrap._swaptSetFilter("all");
    } else if (gridWrap._swaptApplyFilter) {
      gridWrap._swaptApplyFilter();
    }
  }

  function bindAtcIntercept(root, cfg) {
    root.addEventListener(
      "click",
      function (e) {
        var atc = e.target.closest("[data-swapt-ajax-atc]");
        if (!atc || !root.contains(atc)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var card = atc.closest("[data-swapt-card]");
        if (!card) return;
        var role = card.getAttribute("data-swapt-role");
        var state = root.getAttribute("data-swapt-state") || "locked";
        var variantId = selectedVariantId(card);
        if (!variantId || atc.classList.contains("is-loading") || root.dataset.swaptBusy === "1") return;

        if (role === "gift") {
          if (state === "locked") {
            var progress = root.querySelector("[data-swapt-progress]");
            if (progress) progress.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
          }
          var currentGift = giftLine(root._swaptLastCart || { items: [] }, cfg);
          if (currentGift && String(currentGift.product_id) === String(card.getAttribute("data-product-id"))) return;
          function addGift() {
            root.dataset.swaptBusy = "1";
            root.dataset.swaptGiftAdding = "1";
            if (!atc.dataset.swaptLabel) atc.dataset.swaptLabel = atc.textContent;
            atc.textContent = "Adding…";
            setLoading(atc, true);
            atc.disabled = true;
            addLine(
              { items: [{ id: Number(variantId), quantity: 1, properties: { _swapt_gift: "1" } }] },
              function () {
                root.dataset.swaptBusy = "";
                root.dataset.swaptGiftAdding = "";
                atc.textContent = atc.dataset.swaptLabel || "Add to Cart";
                setLoading(atc, false);
                atc.disabled = false;
              },
              true
            );
          }
          if (!atc.dataset.swaptLabel) atc.dataset.swaptLabel = atc.textContent;
          atc.textContent = "Adding…";
          setLoading(atc, true);
          atc.disabled = true;
          root.dataset.swaptBusy = "1";
          if (currentGift) {
            changeLineQty(currentGift.key, 0, addGift);
            return;
          }
          addGift();
          return;
        }

        if (cfg.requirement === "subscription") {
          var planId = card.getAttribute("data-swapt-plan-id");
          if (!planId) return;
          root.dataset.swaptBusy = "1";
          setLoading(atc, true);
          atc.disabled = true;
          addLine(
            {
              items: [
                {
                  id: Number(variantId),
                  quantity: 1,
                  selling_plan: parseInt(planId, 10),
                },
              ],
            },
            function () {
              root.dataset.swaptBusy = "";
              atc.disabled = false;
              setLoading(atc, false);
            },
            true
          );
          return;
        }

        root.dataset.swaptBusy = "1";
        setLoading(atc, true);
        atc.disabled = true;
        addLine(
          { items: [{ id: Number(variantId), quantity: 1 }] },
          function () {
            root.dataset.swaptBusy = "";
            atc.disabled = false;
            setLoading(atc, false);
          },
          true
        );
      },
      true
    );
  }

  function bindSheet(root, cfg) {
    var sheetEl = document.getElementById("bbe-quick-add-sheet");
    var overlay = document.getElementById("bbe-sheet-overlay");
    if (!sheetEl) return;

    var refs = {
      el: sheetEl,
      overlay: overlay,
      img: document.getElementById("bbe-sheet-img"),
      title: document.getElementById("bbe-sheet-title"),
      price: document.getElementById("bbe-sheet-price"),
      compare: document.getElementById("bbe-sheet-compare"),
      save: document.getElementById("bbe-sheet-save"),
      variants: document.getElementById("bbe-sheet-variants"),
      varLabel: document.getElementById("bbe-sheet-variant-label"),
      varBlock: document.getElementById("bbe-sheet-variants-block"),
      plans: document.getElementById("bbe-sheet-plans"),
      planBlock: document.getElementById("bbe-sheet-plan-block"),
      add: document.getElementById("bbe-sheet-add-btn"),
      details: document.getElementById("bbe-sheet-details-link"),
      close: document.getElementById("bbe-sheet-close"),
      loading: document.getElementById("bbe-sheet-loading"),
    };
    var state = { product: null, variant: null, planId: null, trigger: null };

    function showLoading(on) {
      if (!refs.loading) return;
      refs.loading.classList.toggle("is-active", on);
      refs.loading.setAttribute("aria-hidden", on ? "false" : "true");
    }

    function openDom() {
      refs.el.classList.add("is-open");
      refs.el.setAttribute("aria-hidden", "false");
      if (refs.overlay) refs.overlay.classList.add("is-active");
      document.body.style.overflow = "hidden";
    }

    function closeSheet() {
      refs.el.classList.remove("is-open");
      refs.el.setAttribute("aria-hidden", "true");
      if (refs.overlay) refs.overlay.classList.remove("is-active");
      document.body.style.overflow = "";
      if (state.trigger && document.body.contains(state.trigger)) state.trigger.focus();
      state.product = null;
      state.variant = null;
      state.planId = null;
      state.trigger = null;
    }

    function skioGroups(product) {
      return (product.selling_plan_groups || []).filter(function (g) {
        return String(g.app_id || "").toUpperCase() === "SKIO";
      });
    }

    function populatePlans(groups) {
      if (!refs.plans) return;
      var plans = groups.flatMap(function (g) {
        return g.selling_plans || [];
      });
      if (!plans.length) {
        refs.planBlock.hidden = true;
        state.planId = null;
        return;
      }
      refs.planBlock.hidden = false;
      refs.plans.innerHTML = plans
        .map(function (p, i) {
          var adj = p.price_adjustments && p.price_adjustments[0];
          var pct = adj && adj.value_type === "percentage" ? adj.value : 0;
          return (
            '<button class="bbe-sheet__plan-btn' +
            (i === 0 ? " is-selected" : "") +
            '" type="button" data-plan-id="' +
            p.id +
            '" aria-pressed="' +
            (i === 0 ? "true" : "false") +
            '"><span class="bbe-sheet__plan-label">' +
            escapeHtml(p.name) +
            (pct ? '<span class="bbe-sheet__plan-badge">Save ' + pct + "%</span>" : "") +
            "</span></button>"
          );
        })
        .join("");
      state.planId = String(plans[0].id);
      refs.plans.querySelectorAll(".bbe-sheet__plan-btn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          refs.plans.querySelectorAll(".bbe-sheet__plan-btn").forEach(function (b) {
            b.classList.remove("is-selected");
            b.setAttribute("aria-pressed", "false");
          });
          btn.classList.add("is-selected");
          btn.setAttribute("aria-pressed", "true");
          state.planId = btn.getAttribute("data-plan-id");
        });
      });
    }

    function paintVariant(variant) {
      state.variant = variant;
      if (refs.price) refs.price.textContent = formatMoney(variant.price);
      if (refs.compare) {
        var hasCompare = variant.compare_at_price > variant.price;
        refs.compare.textContent = hasCompare ? formatMoney(variant.compare_at_price) : "";
        refs.compare.hidden = !hasCompare;
      }
      if (refs.save) {
        if (variant.compare_at_price > variant.price) {
          var saved = variant.compare_at_price - variant.price;
          var pct = Math.round((saved / variant.compare_at_price) * 100);
          refs.save.textContent = "Save " + pct + "%";
          refs.save.hidden = false;
        } else {
          refs.save.hidden = true;
        }
      }
      if (refs.add) {
        refs.add.disabled = !variant.available || !state.planId;
        refs.add.textContent = variant.available ? "Subscribe & add" : "Sold out";
      }
    }

    function populate(product) {
      state.product = product;
      var img = product.featured_image || (product.images && product.images[0]);
      if (refs.img && img) {
        refs.img.src = String(img).indexOf("//") === 0 ? "https:" + img : img;
        refs.img.alt = product.title || "";
      }
      if (refs.title) refs.title.textContent = product.title || "";
      if (refs.details) refs.details.href = "/products/" + product.handle;
      var groups = skioGroups(product);
      populatePlans(groups);
      var optionName = (product.options && product.options[0]) || "Option";
      if (refs.varLabel) refs.varLabel.textContent = optionName;
      var variants = product.variants || [];
      if (refs.varBlock) refs.varBlock.hidden = variants.length <= 1;
      if (refs.variants) {
        refs.variants.innerHTML = variants
          .map(function (v, i) {
            return (
              '<button class="bbe-sheet__variant' +
              (i === 0 ? " is-selected" : "") +
              '" type="button" data-variant-id="' +
              v.id +
              '"' +
              (v.available ? "" : " disabled") +
              ">" +
              escapeHtml(v.title) +
              "</button>"
            );
          })
          .join("");
        refs.variants.querySelectorAll(".bbe-sheet__variant").forEach(function (btn) {
          btn.addEventListener("click", function () {
            if (btn.disabled) return;
            refs.variants.querySelectorAll(".bbe-sheet__variant").forEach(function (b) {
              b.classList.remove("is-selected");
            });
            btn.classList.add("is-selected");
            var id = Number(btn.getAttribute("data-variant-id"));
            var variant = variants.find(function (v) {
              return v.id === id;
            });
            if (variant) paintVariant(variant);
          });
        });
      }
      var first =
        variants.find(function (v) {
          return v.available;
        }) || variants[0];
      if (first) paintVariant(first);
      if (!groups.length && refs.add) {
        refs.add.disabled = true;
        refs.add.textContent = "Subscription not available";
      }
    }

    function addToCart() {
      if (!state.variant || !state.planId) return;
      var payload = {
        items: [
          {
            id: state.variant.id,
            quantity: 1,
            selling_plan: parseInt(state.planId, 10),
          },
        ],
      };
      refs.add.disabled = true;
      addLine(
        payload,
        function () {
          refs.add.disabled = false;
          closeSheet();
        },
        true
      );
    }

    root._swaptOpenSheet = function (handle, trigger) {
      if (!handle) return;
      state.trigger = trigger;
      showLoading(true);
      openDom();
      fetch(PRODUCT_URL(handle), { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("product");
          return r.json();
        })
        .then(populate)
        .catch(function () {
          closeSheet();
        })
        .finally(function () {
          showLoading(false);
        });
    };

    if (refs.close) refs.close.addEventListener("click", closeSheet);
    if (refs.overlay) refs.overlay.addEventListener("click", closeSheet);
    if (refs.add) refs.add.addEventListener("click", addToCart);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && refs.el.classList.contains("is-open")) closeSheet();
    });
  }

  function boot() {
    watchBlockingCampaigns();
    applyDiscountFromUrl();
    document.querySelectorAll("[data-swapt-bogo]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
